const routers = [
    {
        path: '/policy_info',
        name: 'policy_info',
        meta: {
            exp: '科技政策',
            requireAuth: false
        },
        component: () => import('@/views/policy_info/list/index.vue')
    },
    {
        path: '/policy_info_detail',
        name: 'policy_info_detail',
        meta: {
            exp: '科技政策详情',
            requireAuth: false
        },
        component: () => import('@/views/policy_info/detail/index.vue')
    },
    {
        path: '/policy_info_contrast',
        name: 'policy_info_contrast',
        meta: {
            exp: '政策对比',
            requireAuth: false
        },
        component: () => import('@/views/policy_info/contrast.vue')
    },
]
export default routers
